import { Injectable } from '@angular/core'
import { Gate } from './gate'

@Injectable()
export class GateSerializer {
  fromJson(json: any): Gate {
    const gate = {
      ...json
    }

    return gate
  }

  toJson(gate: Gate): any {
    return {
      ...gate
    }
  }
}
